import { useCallback } from 'react';

import useCopyToClipboard from '@/hooks/useCopyToClipboard';

import { BaseEventType } from '../../hooks/useBaseEvents/events';

export interface CopyRouteToClipboardEventType extends BaseEventType {
  type: 'copy-route-to-clipboard';
  params: {
    url: string;
    query?: Record<string, string>;
  };
}

const useCopyRouteToClipboardEvent = () => {
  const { onCopyRoute } = useCopyToClipboard();

  return useCallback(
    (event: CopyRouteToClipboardEventType) => {
      const { url, query } = event.params;
      onCopyRoute(url, query);
    },
    [onCopyRoute],
  );
};

export default useCopyRouteToClipboardEvent;
